import type {
  TSupervisorApplicationsRequest,
  TSupervisorDocumentTemplate,
} from '~/store/covenants/types.ts';

export const getRequestErrorStatus = (error: unknown): number | undefined => {
  const normalizedError = error as
    | {
        status?: number;
        response?: { status?: number };
        data?: { status?: number };
      }
    | undefined;

  return (
    normalizedError?.status ?? normalizedError?.response?.status ?? normalizedError?.data?.status
  );
};

export const isSupervisorDocumentTemplate = (
  value: unknown
): value is TSupervisorDocumentTemplate => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const { id, name } = value as Partial<TSupervisorDocumentTemplate>;

  return Number.isFinite(id) && typeof name === 'string' && !!name.trim();
};

export const buildSupervisorApplicationsParams = ({
  page,
  size,
  fromDate,
  toDate,
  search,
  assignee,
  segmentId,
  status,
  sort,
  documentIds,
  yearPeriod,
  childPeriod,
  startDeadLine,
  endDealLine,
}: TSupervisorApplicationsRequest) => {
  const params = new URLSearchParams();

  params.append('page', String(page));
  params.append('size', String(size));
  params.append('fromDate', fromDate);
  params.append('toDate', toDate);

  if (search?.trim()) {
    params.append('search', search.trim());
  }

  assignee?.forEach((assigneeValue) => {
    if (assigneeValue.trim()) {
      params.append('assignee', assigneeValue.trim());
    }
  });

  segmentId?.forEach((segmentIdValue) => {
    if (segmentIdValue.trim()) {
      params.append('segmentId', segmentIdValue.trim());
    }
  });

  status?.forEach((statusValue: NonNullable<TSupervisorApplicationsRequest['status']>[number]) => {
    params.append('status', statusValue);
  });

  sort?.forEach((sortValue) => {
    params.append('sort', sortValue);
  });

  documentIds?.forEach((documentId) => {
    if (documentId.trim()) {
      params.append('documentIds', documentId.trim());
    }
  });

  if (yearPeriod?.trim()) {
    params.append('yearPeriod', yearPeriod.trim());
  }

  if (childPeriod) {
    params.append('childPeriod', childPeriod);
  }

  if (startDeadLine?.trim()) {
    params.append('startDeadLine', startDeadLine.trim());
  }

  if (endDealLine?.trim()) {
    params.append('endDealLine', endDealLine.trim());
  }

  return params;
};
